export default {
    name: 'store',
    getString: function(key, defaultVal = null) {
        let val = window.localStorage.getItem(key);
        //console.log(key+" "+val)
        if (val === null) {
            val = defaultVal;
        }

        if (typeof(val) == 'undefined') {
            val = null;
        }
        return val;
    },

    setString: function(key, val) {
        window.localStorage.setItem(key, val);
    },

    getObj: function(key, defaultObj = {}) {
        let val = this.getString(key, null);

        if (typeof(val) == 'string') {
            return JSON.parse(val);
        }

        return defaultObj;
    },

    setObj: function(key, obj) {
        this.setString(key, JSON.stringify(obj));
    },
    clear: function(key=''){
    	if(key != ''){
    		for(var l in  window.localStorage){
        		if(l.startsWith(key)){
        			this.setString(l, '')
        		}
        	}
    	} else {
    		window.localStorage.clear();
    	}
    }

}